// import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
// import { siteConfig } from "../data/siteConfig";

// const CTASection = () => (
//   <section className="cta-banner">
//     <div className="container">
//       <h2>Planning a Wedding, Party or Corporate Event?</h2>
//       <p>Let our team turn your celebration into an unforgettable memory at USHA Resort, Patna.</p>
//       <div className="cta-btns">
//         <a href={siteConfig.phoneHref} className="btn btn-gold"><FaPhoneAlt /> Call Us Now</a>
//         <a
//           href={`https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent("Hello USHA Resort! I want to enquire about an event.")}`}
//           target="_blank" rel="noreferrer" className="btn btn-outline-white"
//         >
//           <FaWhatsapp /> WhatsApp Enquiry
//         </a>
//       </div>
//     </div>
//   </section>
// );

// export default CTASection;

// import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
// import { siteConfig } from "../data/siteConfig";

// const CTASection = () => (
//   <section
//     className="cta-banner"
//     style={{
//       backgroundImage: `linear-gradient(rgba(9, 42, 32, 0.82), rgba(9, 42, 32, 0.88)), url("/images/Banquet/Hall-2.jpeg")`,
//     }}
//   >
//     <div className="container">
//       <h2>Planning a Wedding, Party or Corporate Event?</h2>
//       <p>Let our team turn your celebration into an unforgettable memory at USHA Resort, Patna.</p>
//       <div className="cta-btns">
//         <a href={siteConfig.phoneHref} className="btn btn-gold"><FaPhoneAlt /> Call Us Now</a>
//         <a
//           href={`https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent("Hello USHA Resort! I want to enquire about an event.")}`}
//           target="_blank" rel="noreferrer" className="btn btn-outline-white"
//         >
//           <FaWhatsapp /> WhatsApp Enquiry
//         </a>
//       </div>
//     </div>
//   </section>
// );

// export default CTASection;


import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { siteConfig } from "../data/siteConfig";

// 👇 webpack bundles this image — path is relative to THIS file
// ⚠️ must match your real filename EXACTLY (.JPG / .jpg / .jpeg)
import ctaBg from "../assets/cta/Hall-3.JPG";

const CTASection = () => (
  <section
    className="cta-banner"
    style={{
      backgroundImage: `linear-gradient(rgba(9, 42, 32, 0.82), rgba(9, 42, 32, 0.88)), url(${ctaBg})`,
    }}
  >
    <div className="container">
      <h2>Planning a Wedding, Party or Corporate Event?</h2>
      <p>Let our team turn your celebration into an unforgettable memory at USHA Resort, Patna.</p>
      <div className="cta-btns">
        <a href={siteConfig.phoneHref} className="btn btn-gold"><FaPhoneAlt /> Call Us Now</a>
        <a
          href={`https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent("Hello USHA Resort! I want to enquire about an event.")}`}
          target="_blank" rel="noreferrer" className="btn btn-outline-white"
        >
          <FaWhatsapp /> WhatsApp Enquiry
        </a>
      </div>
    </div>
  </section>
);

export default CTASection;